import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M22.5 5.79209C21.7559 6.13846 20.9548 6.3727 20.1145 6.47736C20.9727 5.93911 21.6311 5.08564 21.9414 4.06896C21.1379 4.56733 20.25 4.9299 19.3015 5.12427C18.5456 4.27828 17.4651 3.75 16.2694 3.75C13.9766 3.75 12.1165 5.69989 12.1165 8.10455C12.1165 8.44594 12.1521 8.77736 12.2235 9.09632C8.7706 8.91441 5.70998 7.18256 3.65967 4.54491C3.3019 5.1903 3.09746 5.93911 3.09746 6.73651C3.09746 8.24659 3.83082 9.57974 4.94572 10.3609C4.26585 10.3398 3.62401 10.1417 3.063 9.81771V9.87129C3.063 11.9819 4.49525 13.7424 6.39699 14.1411C6.04873 14.2433 5.68146 14.2944 5.3023 14.2944C5.03487 14.2944 4.77338 14.2682 4.52021 14.2171C5.04913 15.9465 6.58241 17.2061 8.40095 17.2398C6.9794 18.4085 5.187 19.1049 3.24128 19.1049C2.9061 19.1049 2.57448 19.085 2.25 19.0451C4.08875 20.2786 6.27338 21 8.61846 21C16.2611 21 20.439 14.3654 20.439 8.6104C20.439 8.42102 20.4354 8.23164 20.4283 8.04599C21.2401 7.43174 21.9449 6.66549 22.5 5.79209Z",
  fill: "#1FA1F1"
}, null, -1);
const _hoisted_2 = [
  _hoisted_1
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_2);
}
const icV2LogoTwitterColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2LogoTwitterColor as default
};
